import { Category } from '@/@types/category';
import { Modal } from '@/components/common';
import { Close } from '@mui/icons-material';
import { DialogTitle, IconButton, LinearProgress } from '@mui/material';
import { CategoryForm, CategoryFormData } from '../CategoryForm';
import { CategoryFormPlaceholder } from '../CategoryForm/CategoryFormPlaceholder';

interface ICategoryModalProps {
  category?: Category;
  isOpen: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (data: CategoryFormData) => void;
}

export function CategoryModal({
  category,
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  isSubmitting,
}: ICategoryModalProps) {
  return (
    <Modal open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle id="scroll-dialog-title" sx={{ p: 2 }}>
        {category ? 'Alterar Categoria' : 'Nova Categoria'}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 16,
            top: 12,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      {isSubmitting ? <LinearProgress /> : null}
      {isLoading ? (
        <CategoryFormPlaceholder />
      ) : (
        <CategoryForm
          category={category}
          isLoading={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onClose}
        />
      )}
    </Modal>
  );
}
